import { Action } from "redux";

export const SET_WIZARD_PORTAL_URL = "SET_WIZARD_PORTAL_URL";

export interface SetWizardPortalUrlAction extends Action {
    url: string;
}

export const setWizardPortalUrlAction = (url: string): SetWizardPortalUrlAction => {
    return {
        type: SET_WIZARD_PORTAL_URL,
        url: url,
    };
};
